

import React from "react";
import {
  FaLeaf,
  FaGlobeAsia,
  FaTruck,
  FaAward,
} from "react-icons/fa";

import about from "../assests/coconutMixed.png";

const AboutUs = () => {
  return (
    <section id="about" className="bg-white py-16 lg:py-24">

      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">

        {/* Heading */}

        <div className="text-center mb-12 lg:mb-16">

          <p className="text-green-700 font-semibold uppercase tracking-[4px] text-sm md:text-base">
            About Us
          </p>

          <h2 className="mt-4 font-bold text-gray-900 leading-tight text-3xl sm:text-4xl lg:text-5xl">

            Bringing Nature's Finest Coconuts

            <span className="block lg:inline text-green-700">
              {" "}
              From Our Farm to Your Doorstep
            </span>

          </h2>

          <div className="w-24 h-1 bg-green-700 mx-auto mt-6 rounded-full"></div>

        </div>

        {/* Content */}

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Image */}

          <div className="overflow-hidden rounded-3xl shadow-2xl">

            <img
              src={about}
              alt="Coconut Farm"
              className="w-full h-[300px] sm:h-[420px] lg:h-[550px] object-cover hover:scale-105 duration-500"
            />

          </div>

          {/* Right Side */}

          <div>

            <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-6">

              Premium Coconut Products with Trusted Quality

            </h3>

            <p className="text-gray-600 leading-8 text-base lg:text-lg mb-6">

              We are passionate coconut growers and suppliers committed
              to delivering fresh, healthy and naturally grown coconut
              products. From carefully harvested fresh coconuts to
              premium coconut oil, coconut leaves, coir products and
              tender coconuts, every product is selected to ensure
              superior quality and freshness.

            </p>

            <p className="text-gray-600 leading-8 text-base lg:text-lg mb-10">

              Our mission is to connect farms directly with customers,
              retailers, wholesalers and exporters while promoting
              sustainable farming practices and delivering products
              that meet international quality standards.

            </p>

            {/* Features */}

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">

              {/* Feature */}

              <div className="flex gap-4 p-4 rounded-xl hover:shadow-lg transition">

                <FaLeaf className="text-4xl text-green-700 flex-shrink-0" />

                <div>

                  <h4 className="font-bold text-lg">
                    Farm Fresh
                  </h4>

                  <p className="text-gray-500 mt-2 text-sm leading-6">
                    Harvested directly from our farms for maximum freshness.
                  </p>

                </div>

              </div>

              <div className="flex gap-4 p-4 rounded-xl hover:shadow-lg transition">

                <FaAward className="text-4xl text-yellow-500 flex-shrink-0" />

                <div>

                  <h4 className="font-bold text-lg">
                    Premium Quality
                  </h4>

                  <p className="text-gray-500 mt-2 text-sm leading-6">
                    Carefully selected products with export-grade quality.
                  </p>

                </div>

              </div>

              <div className="flex gap-4 p-4 rounded-xl hover:shadow-lg transition">

                <FaTruck className="text-4xl text-blue-600 flex-shrink-0" />

                <div>

                  <h4 className="font-bold text-lg">
                    Fast Delivery
                  </h4>

                  <p className="text-gray-500 mt-2 text-sm leading-6">
                    Safe and reliable logistics for domestic and bulk orders.
                  </p>

                </div>

              </div>

              <div className="flex gap-4 p-4 rounded-xl hover:shadow-lg transition">

                <FaGlobeAsia className="text-4xl text-green-600 flex-shrink-0" />

                <div>

                  <h4 className="font-bold text-lg">
                    Export Ready
                  </h4>

                  <p className="text-gray-500 mt-2 text-sm leading-6">
                    Serving wholesalers, retailers and export companies.
                  </p>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </section>
  );
};

export default AboutUs;